<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申请人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申请部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">招待时间</span>
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                v-decorator="[
                  'entertainTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">招待地点</span>
              <a-radio-group
                v-decorator="[
                  'entertainLocation',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-radio value="inside">院内</a-radio>
                <a-radio value="outside">院外</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">招待类型</span>
              <a-select
                v-decorator="[
                  'entertainType',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                @change="onEntertainTypeChange"
              >
                <a-select-option
                  v-for="item in entertainTypeList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">招待对象</span>
              <a-input
                v-decorator="[
                  'entertainObject',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">对方人数</span>
              <a-input-number
                :min="1"
                style="width: 100%"
                v-decorator="[
                  'guestCount',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                @change="onGuestCountChange"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">我方人数</span>
              <a-input-number
                :min="1"
                style="width: 100%"
                v-decorator="[
                  'ourCount',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                @change="onOurCountChange"
              />
              <div v-if="maxOurCount !== null" style="color: #faad14; font-size: 12px; line-height: 1.5; margin-top: 4px;">
                我方人数上限：{{ maxOurCount }}人
              </div>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">外部工作人员人数</span>
              <a-input-number
                :min="0"
                style="width: 100%"
                v-decorator="[
                  'staffCount',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                @change="onStaffCountChange"
              />
              <div style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;">含司机等辅助人员</div>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                  <span slot="label">酒水预算(元)</span>
                  <a-input-number
                          :min="0"
                          :precision="2"
                          style="width: 100%"
                          v-decorator="['alcoholBudget']"
                          :disabled="true"
                  />
                  <div style="color: #f5222d; font-size: 12px; line-height: 1.5; margin-top: 4px;">总体预算金额包含酒水预算金额</div>
              </a-form-item>
          </a-col>




          <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                  <span slot="label">总体预算(含酒水)(元)</span>
                  <a-input-number
                          :min="0"
                          :precision="2"
                          style="width: 100%"
                          v-decorator="[
                'totalBudget',
                { rules: [{ required: true, message: '请输入！' }] },
              ]"
                          @change="onTotalBudgetChange"
                  />
              </a-form-item>
          </a-col>



          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span slot="label">是否领用酒水</span>
              <a-select
                v-decorator="[
                  'needAlcohol',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                @change="onNeedAlcoholChange"
              >
                <a-select-option value="1">是</a-select-option>
                <a-select-option value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                  <span slot="label">人均预算(元)</span>
                  <span style="line-height: 32px; color: #1890ff; font-size: 14px; font-weight: bold;">
              {{ perCapitaBudget || '0.00' }}
            </span>
              </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                  <span slot="label">可报销餐费(元)</span>
                  <span style="line-height: 32px; color: #1890ff; font-size: 14px; font-weight: bold;">
              {{ reimbursableBudget || '0.00' }}
            </span>
              </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="事由"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'remarks',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">酒水领用清单</div>
          <AddAlcohol @add="addAlcohol" :canEdit="canEdit"/>
        </div>

        <a-table bordered :dataSource="alcoholList" :pagination="false">
          <a-table-column title="酒水品名" data-index="name"> </a-table-column>

          <a-table-column title="库存" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">
                {{ text.quantity }}
              </span>
            </template>
          </a-table-column>

          <a-table-column title="类型">
            <template slot-scope="text">
              <div class="left">
                <DataDictFinder dictType="invType" :dictValue="text.typeInv" />
                <span>-</span>
                {{ renderSubType(text.typeInv, text.typeSub) }}
              </div>
            </template>
          </a-table-column>

          <a-table-column title="单位" data-index="unit" align="center">
          </a-table-column>
          <a-table-column title="单价" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ text.unitPrice }}</span>
            </template>
          </a-table-column>

          <a-table-column title="申领数量" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ text.needQuantity }}</span>
            </template>
          </a-table-column>

          <a-table-column title="小计金额" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ text.totalPrice }}</span>
            </template>
          </a-table-column>

          <a-table-column title="操作" align="center" width="100px">
            <template slot-scope="text, record, index">
              <a href="#" class="danger" @click.prevent="removeAlcohol(index)">
                移除
              </a>
            </template>
          </a-table-column>
        </a-table>

        <div class="rule-box">
          <div class="rule-title">业务关系及招待事由</div>
          <div class="rule-sub">我方人数：</div>
          <div class="rule-item">商务招待:招待对象在5人以内的，陪餐人数不得超过5人;招待对象超过5人的，新增陪餐人数不得超过新增招待对象人数的三分之一，自助餐除外。</div>
          <div class="rule-item">内部业务招待及其他公务招待:招待人数在10人以内的，陪餐人数不得超过3人;招待人数超过10人的，不得超过招待人数的三分之一。</div>
          <div class="rule-sub" style="margin-top: 8px;">费用预算：</div>
          <div class="rule-item">重要商务招待：每次人均不得超过500元（含酒水、饮料）</div>
          <div class="rule-item">一般商务招待：每次人均不得超过300元（含酒水、饮料），不得提供香烟和高档酒水</div>
          <div class="rule-item">其他公务：工作餐人均不得超过150元/次（不得提供香烟和酒水）</div>
          <div class="rule-item">内部业务招待：工作餐重要级人均不得超过150元/天，一般级人均不得超过130元/天，不得提供香烟，不上酒。</div>
          <div class="rule-item">客方工作人员（含司机）工作餐：人均不得超过50元/次</div>
          <div class="rule-divider"></div>
          <div class="rule-item">商务招待酒水实行集中采购，内部领用，业务招待费中不单独报销酒水费用。</div>
          <div class="rule-item">总体预算金额包含酒水预算金额</div>
        </div>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AddAlcohol from "./components/add-alcohol.vue";
import { apply, fetchApplyDetail, reapply } from "@/api/oa/entertain";
import moment from "moment";

export default {
  components: {
    AddAlcohol,
  },

  data() {
    return {
      form: this.$form.createForm(this),
      alcoholList: [],
      loading: false,
      id: null,
      needAlcoholValue: "1",
      guestCountValue: null,
      ourCountValue: null,
      staffCountValue: null,
      totalBudgetValue: null,
      entertainTypeValue: null,
    };
  },

  mounted() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id) {
      this.id = id;
      fetchApplyDetail({ id }).then((res) => {
        console.log("result", res);
        if (res) {
          this.needAlcoholValue = res.needAlcohol || "1";
          this.guestCountValue = res.guestCount;
          this.ourCountValue = res.ourCount;
          this.staffCountValue = res.staffCount;
          this.totalBudgetValue = res.totalBudget;
          this.entertainTypeValue = res.entertainType;
          this.form.setFieldsValue({
            entertainTime: res.entertainTime ? moment(res.entertainTime) : null,
            entertainLocation: res.entertainLocation,
            entertainType: res.entertainType,
            entertainObject: res.entertainObject,
            guestCount: res.guestCount,
            ourCount: res.ourCount,
            totalBudget: res.totalBudget,
            alcoholBudget: res.alcoholBudget,
            needAlcohol: res.needAlcohol,
            staffCount: res.staffCount,
            remarks: res.remarks,
          });

          this.alcoholList = Array.isArray(res.applyMaterials)
            ? res.applyMaterials.map((item) => {
                return {
                  needQuantity: item.quantity,
                  totalPrice: item.totalPrice,
                  materialId: item.materialVo ? item.materialVo.id : null,
                  name: item.name,
                  typeInv: item.typeInv,
                  typeSub: item.typeSub,
                  unit: item.unit,
                  unitPrice: item.unitPrice,
                  quantity: item.materialVo ? item.materialVo.quantity : 0,
                };
              })
            : [];
        }
      });
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),
    ...mapGetters("setting", ["findDataDict"]),

    entertainTypeList() {
      return this.findDataDict("entertainType");
    },

    typeList() {
      return this.findDataDict("invType");
    },

    // 酒水预算 = 酒水清单各行的 totalPrice 之和
    alcoholBudget() {
      return this.alcoholList.reduce((sum, item) => sum + parseFloat(item.totalPrice || 0), 0);
    },

    // 是否领用酒水为"是"时才可编辑酒水清单
    canEdit() {
      return this.needAlcoholValue === "1";
    },

    // 人均预算 = (总体预算 - 外部工作人员人数 * 50) / (对方人数 + 我方人数)
    perCapitaBudget() {
      const total = this.totalBudgetValue;
      const guest = this.guestCountValue;
      const our = this.ourCountValue;
      const staff = this.staffCountValue || 0;
      if (total != null && guest != null && our != null) {
        return ((parseFloat(total) - parseInt(staff) * 50) / (parseInt(guest) + parseInt(our))).toFixed(2);
      }
      return '0.00';
    },

    // 可报销餐费 = 总体预算 - 酒水预算
    reimbursableBudget() {
      const total = this.totalBudgetValue;
      const alcohol = this.alcoholBudget;
      if (total != null) {
        return (parseFloat(total) - parseFloat(alcohol || 0)).toFixed(2);
      }
      return '0.00';
    },

    maxOurCount() {
      const type = this.entertainTypeValue;
      const guest = parseInt(this.guestCountValue) || 0;
      if (!type || !guest) return null;
      if (type === 'important_business' || type === 'general_business') {
        if (guest <= 5) return 5;
        return 5 + Math.floor((guest - 5) / 3);
      } else if (type === 'other_official' || type === 'internal_business') {
        if (guest <= 10) return 3;
        return Math.floor(guest / 3);
      }
      return null;
    },
  },

  watch: {
    alcoholList: {
      handler() {
        this.form.setFieldsValue({ alcoholBudget: this.alcoholBudget });
      },
      deep: true,
    },
  },

  methods: {
    disabledDate(current) {
      // 不能选择上个月及之前的日期，只能选择本月或之后
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const dateYear = current.year();
      const dateMonth = current.month();
      return dateYear < currentYear || (dateYear === currentYear && dateMonth < currentMonth);
    },
    onGuestCountChange(value) {
      this.guestCountValue = value;
    },
    onOurCountChange(value) {
      this.ourCountValue = value;
    },
    onStaffCountChange(value) {
      this.staffCountValue = value;
    },
    onTotalBudgetChange(value) {
      this.totalBudgetValue = value;
    },
    onEntertainTypeChange(value) {
      this.entertainTypeValue = value;
    },
    onNeedAlcoholChange(value) {
      this.needAlcoholValue = value;
      if (value !== "1") {
        this.alcoholList = [];
        this.form.setFieldsValue({ alcoholBudget: 0 });
      }
    },
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    addAlcohol(payload) {
      const index = this.alcoholList.findIndex(
        (item) => item.materialId === payload.materialId
      );
      if (index === -1) {
        this.alcoholList.push(payload);
      } else {
        this.alcoholList.splice(index, 1, payload);
      }
    },

    removeAlcohol(index) {
      this.alcoholList.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const needAlcohol = values.needAlcohol;
          if (needAlcohol === "1" && this.alcoholList.length === 0) {
            this.$message.error("请添加领用酒水");
            return;
          }
          if (this.alcoholBudget > values.totalBudget) {
            this.$message.error("酒水预算不能高于总体预算");
            return;
          }

          const { entertainType, guestCount, ourCount } = values;
          if (entertainType === 'important_business' || entertainType === 'general_business') {
            if (guestCount <= 5) {
              if (ourCount > 5) {
                this.$message.error('商务招待: 招待对象在5人以内的，陪餐人数不得超过5人');
                return;
              }
            } else {
              const maxOur = 5 + Math.floor((guestCount - 5) / 3);
              if (ourCount > maxOur) {
                this.$message.error(`商务招待: 招待对象超过5人时，我方人数不得超过${maxOur}人`);
                return;
              }
            }
          } else if (entertainType === 'other_official' || entertainType === 'internal_business') {
            if (guestCount <= 10) {
              if (ourCount > 3) {
                this.$message.error('内部业务招待及其他公务: 招待人数在10人以内的，陪餐人数不得超过3人');
                return;
              }
            } else {
              const maxOur = Math.floor(guestCount / 3);
              if (ourCount > maxOur) {
                this.$message.error(`内部业务招待及其他公务: 招待人数超过10人的，陪餐人数不得超过${maxOur}人`);
                return;
              }
            }
          }

          this.loading = true;
          const {
            entertainTime,
            entertainLocation,
            entertainObject,
            totalBudget,
            needAlcohol: na,
            staffCount,
            remarks,
          } = values;

          // 构造基础参数
          const params = {
            applicantId: this.user.uuid,
            applicantName: this.user.userName,
            deptId: this.department.deptId,
            deptName: this.department.deptUniqueName,
            entertainTime: entertainTime
              ? entertainTime.format("YYYY-MM-DD")
              : null,
            entertainLocation,
            entertainType,
            entertainObject,
            guestCount,
            ourCount,
            staffCount,
            totalBudget,
            alcoholBudget: this.alcoholBudget,
            needAlcohol: na,
            remarks,
          };

          // 如果选择了酒水，添加酒水列表
          if (na === "1") {
            params.materialList = this.alcoholList.map((item) => ({
              materialId: item.materialId,
              name: item.name,
              typeInv: item.typeInv,
              typeSub: item.typeSub,
              unit: item.unit,
              unitPrice: item.unitPrice,
              quantity: item.needQuantity,
              totalPrice: item.totalPrice,
            }));
          }

          if (this.id) {
            reapply({ id: this.id, ...params })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply(params)
              .then(() => {
                this.alcoholList = [];
                this.needAlcoholValue = "1";
                this.form.resetFields();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.hint {
  margin-top: 12px;
  color: #999;
  font-size: 12px;
}

.rule-box {
  margin-top: 24px;
  padding: 16px 20px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.rule-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.rule-item {
  font-size: 12px;
  color: #666;
  line-height: 24px;
}

.rule-sub {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  line-height: 24px;
}

.rule-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0;
}

.center {
  margin-top: 80px;
}
</style>
